import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Contacto } from 'app/models/contacto-model';
import { Services } from 'app/servicios.service';

@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html',
  styleUrls: ['./contacto.component.css']
})
export class ContactoComponent implements OnInit {

  public contacto: FormGroup;
  public mensaje: string = "";
  public icon = {
    url: './assets/img/map-marker-2.png',
    scaledSize: {
      width: 60,
      height: 80
    }};
  lat = -34.286365758468484;
  lng = -57.23419834296226;
  zoom = 16;
  srcMap: string = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3296.003890901192!2d-57.23760982408327!3d-34.29944494149309!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95a3c11f944ba673%3A0xb5bffa12d4bf83e!2sAvenida%20Jos%C3%A9%20Batlle%20y%20Ordo%C3%B1ez%20723%2C%2070300%20Nueva%20Helvecia%2C%20Departamento%20de%20Colonia!5e0!3m2!1sen!2suy!4v1723071272498!5m2!1sen!2suy";
  srcMapOk;
  email;
  nombre;
  texto;
  telefono;
  focus;
  focus1;
  focus2;
  focus3;
  siteKey:string = "6LeKMlgdAAAAAMYfNxYolZ_jr7yZvx4QTCGAgyWc";
  constructor(private formBuilder: FormBuilder, private API: Services, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    window.scroll({ 
      top: 0, 
      behavior: 'smooth' 
    });
    this.srcMapOk = this.sanitizer.bypassSecurityTrustResourceUrl(this.srcMap);
    this.mensaje = "";
    this.contacto = this.formBuilder.group({
      email: new FormControl('', [
          Validators.required,
          Validators.pattern('[^ @]*@[^ @]*')
      ]),
      nombre: new FormControl('', [
          Validators.minLength(4),
          Validators.required
      ]),
      texto: new FormControl('', [
        Validators.minLength(10),
        Validators.required
      ]),
      telefono: new FormControl('', [
        Validators.minLength(8),
        Validators.required
      ]),
      recaptcha: ['', Validators.required]
    });
  }

  EnviarMensaje(email: string, telefono: string, nombre: string, texto: string){
    if(this.contacto.valid)
    {
      var contacto = new Contacto();
      contacto.Email = email;
      contacto.Nombre = nombre;
      contacto.Telefono = telefono;
      contacto.Texto = texto;
      console.log(contacto);
      this.API.enviarMensaje(contacto).subscribe(data => {
        console.log(data);
      });
      this.mensaje = 'Mensaje enviado, nos pondremos en contacto lo antes posible.'
    }else{
    }
  }

  public getError(controlName: string): string {
    let error = '';
    const control = this.contacto.get(controlName);
    if (control.touched && control.errors != null) {
        error = JSON.stringify(control.errors);
    }
    if (error.indexOf('requiredPattern') > -1) {
        error = 'Campo incorrecto, debe ingresar un email';
    }
    if (error.indexOf('minlength') > -1) {
        error = 'Mínimo de caractéres no superado.';
    }
    if (error.indexOf('"required":true') > -1) {
        error = 'Campo requerido';
    }
    return error;
  }

  public getMensaje(): string{
    return this.mensaje;
  }

}
